















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    getCompany,
    postCompany,
    patchCompany,
    getCompanies,
    postCompanyPrescriber,
} from '../api/api';
import Company from '../models/Company';
import moment from 'moment';
import User from '../models/User';
import get from 'lodash/get';
import { BACKEND_URL } from '../helpers/constants';
import { legalForms } from '@/data/legalForms';
import { companyTypes } from '@/data/companyTypes';

@Component({
    components: {
        Forms,
    },
})
export default class ProfileCompany extends Vue {
    @Prop() company!: Company;
    companiesItems: Array<{ text: string; value: number }> = [];
    defaultImages: any | null = null;
    usersItems: Array<{ text: string; value: number }> = [];
    errors: any = {};
    loading: boolean = false;
    type: 'edit' | 'add' = 'edit';

    get items() {
        return [
            {
                name: 'name',
                label: "Nom de l'entreprise *",
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'email',
                label: 'Email *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'legal_form',
                label: 'Forme juridique',
                placeholder: 'À renseigner',
                type: 'select',
                items: this.legalFormsArr,
                errorMessage: 'La forme juridique est requise',
            },
            {
                name: 'type',
                label: "Type de l'entreprise *",
                type: 'select',
                required: true,
                errorMessage: 'Le type est requis',
                items: this.companyTypesArr,
            },
            {
                name: 'description',
                label: 'Présentation promoteur',
                type: 'textarea',
            },
            {
                name: 'commercial_manager_name',
                label: 'Nom du responsable des ventes',
                type: 'text',
            },
            {
                name: 'commercial_manager_email',
                label: 'E-mail du responsable des ventes',
                type: 'email',
            },
            {
                name: 'commercial_manager_phone',
                label: 'Téléphone du responsable des ventes',
                type: 'text',
            },
            {
                name: 'commercial_manager_mobile',
                label: 'Téléphone mobile du responsable des ventes',
                type: 'text',
            },
            {
                name: 'account_manager_name',
                label: 'Nom du responsable comptabilité',
                type: 'text',
            },
            {
                name: 'account_manager_email',
                label: 'E-mail du responsable comptabilité',
                type: 'email',
            },
            {
                name: 'account_manager_phone',
                label: 'Téléphone du responsable comptabilité',
                type: 'text',
            },
            {
                name: 'account_manager_mobile',
                label: 'Téléphone mobile du responsable comptabilité',
                type: 'text',
            },
            {
                name: 'url',
                label: 'Site partenaire',
                type: 'text',
            },
            {
                name: 'siret',
                label: 'Siret',
                type: 'text',
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse *',
                        name: 'street',
                        required: true,
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal *',
                        name: 'postal_code',
                        required: true,
                    },
                    city: {
                        label: 'Ville *',
                        name: 'city',
                        required: true,
                    },
                },
            },
            {
                name: 'comments',
                label: 'Commentaires',
                type: 'textarea',
            },
        ];
    }
    value: any | null = null;
    defaultValue: any = {
        name: null,
        description: null,
        holding: null,
        commercial_manager: null,
        type: null,
        url: null,
        login_site: null,
        password_site: null,
        siret: null,
        legal_form: null,
        email: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        comments: null,
        image: null,
        commercial_manager_name: null,
        commercial_manager_email: null,
        commercial_manager_phone: null,
        commercial_manager_mobile: null,
        account_manager_name: null,
        account_manager_email: null,
        account_manager_phone: null,
        account_manager_mobile: null,
        nb_total_programs: 0,
        nb_programs_to_enter: 0,
        public_site_url: null,
        administrative_comment: null,
        electronic_signature_mandate: 'pending',
        electronic_signature_contract: 'pending',

        // api
        api_available: null,
        api_connected: null,
        dev_comment: null,

        //flux
        flux_methode: null,

        // api documentation
        document_file: null,
        api_documentation: null,
    };

    getValue(value: any) {
        this.value = value;
    }
    mounted() {
        this.onCompany();
    }

    @Watch('company')
    onCompany() {
        this.loading = true;
        if (this.company) {
            this.defaultImages =
                this.company.image &&
                `${BACKEND_URL}${this.company.image.url}${this.company.image.name}.${this.company.image.extension}`;

            this.defaultValue.name = this.company.name || null;
            this.defaultValue.description = this.company.description || null;
            this.defaultValue.holding = this.company.holding
                ? this.company.holding.id
                : '';
            this.defaultValue.type = this.company.type || null;
            this.defaultValue.url = this.company.url || null;
            this.defaultValue.login_site = this.company.login_site || null;
            this.defaultValue.password_site =
                this.company.password_site || null;
            this.defaultValue.siret = this.company.siret || null;
            this.defaultValue.legal_form = this.company.legal_form || null;
            this.defaultValue.email = this.company.email || null;
            this.defaultValue.fax = this.company.fax || null;
            this.defaultValue.phone = this.company.phone || null;
            this.defaultValue.mobile = this.company.mobile || null;
            this.defaultValue.address.street =
                (this.company.address && this.company.address.street) || null;
            this.defaultValue.address.street2 =
                (this.company.address && this.company.address.street2) || null;
            this.defaultValue.address.postal_code =
                (this.company.address && this.company.address.postal_code) ||
                null;
            this.defaultValue.address.city =
                (this.company.address && this.company.address.city) || null;
            this.defaultValue.comments = this.company.comments || null;
            this.defaultValue.commercial_manager_name =
                this.company.commercial_manager_name || null;
            this.defaultValue.commercial_manager_email =
                this.company.commercial_manager_email || null;
            this.defaultValue.commercial_manager_phone =
                this.company.commercial_manager_phone || null;
            this.defaultValue.commercial_manager_mobile =
                this.company.commercial_manager_mobile || null;
            this.defaultValue.account_manager_name =
                this.company.account_manager_name || null;
            this.defaultValue.account_manager_email =
                this.company.account_manager_email || null;
            this.defaultValue.account_manager_phone =
                this.company.account_manager_phone || null;
            this.defaultValue.account_manager_mobile =
                this.company.account_manager_mobile || null;
            this.defaultValue.nb_total_programs =
                this.company.nb_total_programs || 0;
            this.defaultValue.nb_programs_to_enter =
                this.company.nb_programs_to_enter || 0;
            this.defaultValue.public_site_url =
                this.company.public_site_url || null;
            this.defaultValue.administrative_comment =
                this.company.administrative_comment || null;
            this.defaultValue.electronic_signature_mandate =
                this.company.electronic_signature_mandate || 'pending';
            this.defaultValue.electronic_signature_contract =
                this.company.electronic_signature_contract || 'pending';
            // api
            this.defaultValue.api_available =
                this.company.api_available || null;
            this.defaultValue.api_connected =
                this.company.api_connected || null;
            this.defaultValue.dev_comment = this.company.dev_comment || null;
            //flux
            this.defaultValue.flux_methode = 
                this.company.flux_methode || null;
            // api documentation
            this.defaultValue.api_documentation =
                this.company.api_documentation || null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newCompany: Company = {
            name: form.name,
            image: form.image,
            description: form.description,
            type: form.type,
            // holding: form.holding,
            // commercial_manager: form.commercial_manager,
            url: form.url,
            login_site: form.login_site,
            password_site: form.password_site,
            siret: form.siret,
            email: form.email,
            bic: form.bic,
            legal_form: form.legal_form || '',
            rcs: form.rcs,
            share_capital: form.share_capital,
            fax: form.fax,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            nb_total_programs: form.nb_total_programs,
            nb_programs_to_enter: form.nb_programs_to_enter,
            public_site_url: form.public_site_url,
            comments: form.comments,
            administrative_comment: form.administrative_comment,
            commercial_manager_name: form.commercial_manager_name,
            commercial_manager_email: form.commercial_manager_email,
            commercial_manager_phone: form.commercial_manager_phone,
            commercial_manager_mobile: form.commercial_manager_mobile,
            account_manager_name: form.account_manager_name,
            account_manager_email: form.account_manager_email,
            account_manager_phone: form.account_manager_phone,
            account_manager_mobile: form.account_manager_mobile,
            electronic_signature_mandate: form.electronic_signature_mandate,
            electronic_signature_contract: form.electronic_signature_mandate,
            is_multi_fee: form.is_multi_fee,

            multi_boost: form.multi_boost,
            boost_due_date_prescriber:
                form.multi_boost === 'yes'
                    ? form.boost_due_date_prescriber
                    : '',
            boost_due_date_customer:
                form.multi_boost === 'yes' ? form.boost_due_date_customer : '',
            boost_comment_prescriber:
                form.multi_boost === 'yes' ? form.boost_comment_prescriber : '',
            boost_comment_customer:
                form.multi_boost === 'yes' ? form.boost_comment_customer : '',
            is_boost_prescriber:
                form.multi_boost === 'yes' ? form.is_boost_prescriber : '',
            is_boost_customer:
                form.multi_boost === 'yes' ? form.is_boost_customer : '',
            // api
            api_available: form.api_available,
            api_connected: form.api_connected,
            dev_comment: form.dev_comment,
            //flux
            flux_methode: form.flux_methode,
            // api documentation
            document: form.document,
            document_name: form.document_name,
            document2: form.document_2,
            document2_name: form.document2_name,
            document3: form.document_3,
            document3_name: form.document3_name,
        };
        const $vs = (this as any).$vs;
        try {
            await postCompanyPrescriber(newCompany);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Création',
                text: `Création de l'entreprise réussie`,
            });
        } catch (error) {
            this.errors = get(error, 'response.data.errors.children', {});
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }

    get legalFormsArr() {
        return Object.keys(legalForms).map(key => ({
            text: (legalForms as any)[key],
            value: key,
        }));
    }

    get companyTypesArr() {
        return Object.keys(companyTypes).map(key => ({
            text: (companyTypes as any)[key],
            value: key,
        }));
    }
}
